import React, {PureComponent} from 'react';
import {Route} from 'react-router';
import {connect} from 'react-redux';
import cx from 'classnames';
import Theme from 'components/layout/Theme';
import Modal from 'components/common/Modal';
import Header from 'components/layout/Header';
import Body from 'components/layout/Body';
import Footer from 'components/layout/Footer';
import styles from './styles.module.sass';
import Popup from 'components/common/Popup';
import {load} from 'actions/dictionary';
import {popupDelAll, popupShow} from 'actions/popup';
import axios from 'api/defaultAxios';


@connect()
class Main extends PureComponent {
  componentWillMount() {
    const {dispatch} = this.props;

    axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {

      if (error.response === undefined) {
        dispatch(popupShow('Опаньки, что то пошло не так. Возможно проблемы с сетью?', {display: Popup.display.error}));
      }
      else if (error && error.response && error.response.status === 400) {
        dispatch(popupShow(error.response.data, {display: Popup.display.error}));
      }
      else if (error && error.response && error.response.status === 500) {
        let jsonData = JSON.stringify(error.response.data, null, 4);
        dispatch(popupShow('Опаньки, что то пошло не так!', {display: Popup.display.error, text: jsonData}));
      }

      return Promise.reject(error);
    });

    dispatch(load());
    dispatch(popupDelAll());
  };

  render() {
    return [
      <Theme key='main-theme'/>,
      <Modal key='main-modal'/>,
      <Popup key='main-popup'/>,
      <div key='main-content' className={cx('Main', styles.component)}>
        <div className={styles.headerBodyBox}>
          <Header/>
          <Route component={Body}/>
        </div>
        <Footer/>
      </div>
    ];
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/layout/Main/Main.jsx